import { ReactComponent as Bat0 } from "assets/svgs/battery/battery-twotone-0-svgrepo-com.svg";
import { ReactComponent as Bat5 } from "assets/svgs/battery/battery-twotone-05-svgrepo-com.svg";
import { ReactComponent as Bat10 } from "assets/svgs/battery/battery-twotone-10-svgrepo-com.svg";
import { ReactComponent as Bat15 } from "assets/svgs/battery/battery-twotone-15-svgrepo-com.svg";
import { ReactComponent as Bat20 } from "assets/svgs/battery/battery-twotone-20-svgrepo-com.svg";
import { ReactComponent as Bat25 } from "assets/svgs/battery/battery-twotone-25-svgrepo-com.svg";
import { ReactComponent as Bat30 } from "assets/svgs/battery/battery-twotone-30-svgrepo-com.svg";
import { ReactComponent as Bat35 } from "assets/svgs/battery/battery-twotone-35-svgrepo-com.svg";
import { ReactComponent as Bat40 } from "assets/svgs/battery/battery-twotone-40-svgrepo-com.svg";
import { ReactComponent as Bat45 } from "assets/svgs/battery/battery-twotone-45-svgrepo-com.svg";
import { ReactComponent as Bat50 } from "assets/svgs/battery/battery-twotone-50-svgrepo-com.svg";
import { ReactComponent as Bat55 } from "assets/svgs/battery/battery-twotone-55-svgrepo-com.svg";
import { ReactComponent as Bat60 } from "assets/svgs/battery/battery-twotone-60-svgrepo-com.svg";
import { ReactComponent as Bat65 } from "assets/svgs/battery/battery-twotone-65-svgrepo-com.svg";
import { ReactComponent as Bat70 } from "assets/svgs/battery/battery-twotone-70-svgrepo-com.svg";
import { ReactComponent as Bat75 } from "assets/svgs/battery/battery-twotone-75-svgrepo-com.svg";
import { ReactComponent as Bat80 } from "assets/svgs/battery/battery-twotone-80-svgrepo-com.svg";
import { ReactComponent as Bat85 } from "assets/svgs/battery/battery-twotone-85-svgrepo-com.svg";
import { ReactComponent as Bat90 } from "assets/svgs/battery/battery-twotone-90-svgrepo-com.svg";
import { ReactComponent as Bat95 } from "assets/svgs/battery/battery-twotone-95-svgrepo-com.svg";
import { ReactComponent as Bat100 } from "assets/svgs/battery/battery-twotone-100-svgrepo-com.svg";

/** SVGR root svg — explicit size so icons are not collapsed in flex/table layouts. */
const iconFrame = "inline-block h-4 w-4 shrink-0 align-middle";

const BATTERY_ICONS = {
    0: Bat0,
    5: Bat5,
    10: Bat10,
    15: Bat15,
    20: Bat20,
    25: Bat25,
    30: Bat30,
    35: Bat35,
    40: Bat40,
    45: Bat45,
    50: Bat50,
    55: Bat55,
    60: Bat60,
    65: Bat65,
    70: Bat70,
    75: Bat75,
    80: Bat80,
    85: Bat85,
    90: Bat90,
    95: Bat95,
    100: Bat100,
};

function levelToBucket(level) {
    const n = Math.max(0, Math.min(100, level));
    return Math.round(n / 5) * 5;
}

const BatteryIcon = ({ className = "", batteryLevel, showBattery = true, reverse = true }) => {
    const hasData = typeof batteryLevel === "number" && !Number.isNaN(batteryLevel);

    let Icon = Bat0;
    let iconTint = "text-white/75";
    let valueClassName = "";
    let label = "";

    if (!hasData) {
        Icon = Bat0;
        iconTint = "text-white/75";
        valueClassName = "text-black40";
        label = "N/A";
    } else if (batteryLevel > 0) {
        label = `${Math.floor(batteryLevel)}%`;
        const bucket = levelToBucket(batteryLevel);
        Icon = BATTERY_ICONS[bucket] ?? Bat0;
        if (batteryLevel > 50) {
            iconTint = "text-white";
            valueClassName = "text-white";
        } else if (batteryLevel >= 21) {
            iconTint = "text-low";
            valueClassName = "text-low";
        } else {
            iconTint = "text-warning";
            valueClassName = "text-warning";
        }
    } else {
        Icon = Bat0;
        iconTint = "text-warning";
        valueClassName = "text-warning";
        label = "0%";
    }

    const icon = <Icon className={`${iconFrame} ${iconTint}`} />;

    /** Fixed width + left align so digits sit next to the icon; width avoids layout shift. */
    const valueClass =
        "w-[2.5rem] shrink-0 text-left tabular-nums text-h5 leading-none";

    return (
        <div
            className={`inline-flex shrink-0 items-center gap-px ${
                reverse ? "flex-row-reverse" : ""
            } ${className}`}
        >
            <span className="inline-flex shrink-0">{icon}</span>
            {showBattery && (
                <p className={`${valueClass} ${valueClassName}`}>{label}</p>
            )}
        </div>
    );
};

export default BatteryIcon;
